import Card from "components/card";
import Statistics from "./SmallStatistic";
import DollarIcon from "components/icons/WidgetIcon/DollarIcon";
import { useDealData } from "contexts/DealContext";
import { usePortfolioData } from "contexts/PortfolioContext";
import { useViewMode } from "contexts/ViewModeContext";
import { formatCurrency, formatDecimal } from "utils/formatUtils";

const Nursing = () => {
    const { viewMode } = useViewMode();

    // Deal data
    const { currentFacility: dealFacility, selectedPeriod: dealSelectedPeriod } = useDealData();

    // Portfolio data
    const { currentPortfolioFacility, selectedPeriod: portfolioSelectedPeriod } = usePortfolioData();

    // Use appropriate data based on view mode
    const currentFacility = viewMode === 'portfolio' ? currentPortfolioFacility : dealFacility;
    const selectedPeriod = viewMode === 'portfolio' ? portfolioSelectedPeriod : dealSelectedPeriod;

    // Get expense data from the new structure
    const expenseData = currentFacility?.periods?.[selectedPeriod]?.Categories?.Expenses || [];

    // Get nursing data
    const nursingAndMedical = expenseData.find(item => item.Type === "Nursing and Medical") || {};
    const nursingAgency = expenseData.find(item => item.Type === "Nursing Agency") || {};
    const nursingAdmin = expenseData.find(item => item.Type === "Nursing Admin") || {};

    // Common icon component
    const IconWrapper = () => (
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-lightPrimary text-2xl text-brand-500 dark:!bg-navy-700 dark:text-white">
            <DollarIcon width={"10"} />
        </div>
    );

    return (
        <Card extra={"items-center justify-around w-full p-[16px] bg-cover gap-2 flex flex-col"}>
            <h3 className="ml-3 text-med self-start font-bold text-gray-700 dark:text-white">
                Nursing
            </h3>
            <Statistics
                title="Nursing and Medical"
                subtitle1="Annual"
                value1={formatCurrency(nursingAndMedical?.["Annual"])}
                subtitle2="PPD"
                value2={formatDecimal(nursingAndMedical?.["PPD"])}
                icon={<IconWrapper />}
            />
            <Statistics
                title="Nursing Admin"
                subtitle1="Annual"
                value1={formatCurrency(nursingAdmin?.["Annual"])}
                subtitle2="PPD"
                value2={formatDecimal(nursingAdmin?.["PPD"])}
                icon={<IconWrapper />}
            />
            <Statistics
                title="Nursing Agency"
                subtitle1="Annual"
                value1={formatCurrency(nursingAgency?.["Annual"])}
                subtitle2="PPD"
                value2={formatDecimal(nursingAgency?.["PPD"])}
                icon={<IconWrapper />}
            />
        </Card>
    );
};

export default Nursing;